module.exports = __webpack_public_path__ + "static/media/kawari-logo-prod.b57a4fc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/kawari-logo-prod.svg
// module id = 411
// module chunks = 0